import MQ from './mediaqueries';

class Navigation {

    constructor(el, options) {
        this.el = el;

        this.mobileMenuHiddenClass = '-mobile-menu-is-inactive';
        this.bodyOverlayClass = '-main-navigation-sub-menu-is-active';
		this.subMenuHiddenClass = 't-visuallyhidden';
        this.subMenuActiveAttribute = 'data-active';

        // selectors
        this.s = {
            mobileMenu: '[data-menu]',
            menuItem: '[data-li]',
            subNav: '[data-sub]'
        }

        this.showSubNavDelay = null;
        this.subNavDelayValueInMiliseconds = 300;
        this.currentBreakpoint = MQ.currentBreakpoint;

        // We need `this` to reference this Class
        this.registerHandleMouseEnter = e => this.handleMouseEnter(e);
        this.registerHandleMouseLeave = e => this.handleMouseLeave(e);
        this.registerHandleMouseClick = e => this.handleMouseClick(e);

        this.init();
    }

    init() {
        // Hide the mobile menu on init.
        // CSS does not hide it by default so that's is visible without Javascript enabled.
        document.body.classList.add(this.mobileMenuHiddenClass);

        // Make the mobile menu toggable.
        document.querySelector(this.s.mobileMenu).addEventListener('click', () => {
            document.body.classList.toggle(this.mobileMenuHiddenClass);
        });

        // Hide the mobile menu on init.
        // CSS does not hide them by default (on mobile) so that's is visible without Javascript enabled.
        this.hideAllSubNavs();

        // Register event listeners for the sub menu
        this.handleSubMenuEvents();

        // On window resize get the new breakpoint and reset the sub menu event handlers
        window.addEventListener('resize', () => {
            this.currentBreakpoint = MQ.currentBreakpoint;
            this.hideAllSubNavs();
            this.handleSubMenuEvents();
        });

        // Stop propagation when clicked on the sub menu
        this.el.querySelectorAll(this.s.subNav).forEach(el => {
            el.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        });
    }

    handleSubMenuEvents() {
        this.el.querySelectorAll(this.s.menuItem).forEach(el => {
            // Because it's possible to resize your browser and we differentiate between click and hover events
            // we need to remove all event listeners before re-adding them again
            el.removeEventListener('mouseenter', this.registerHandleMouseEnter);
            el.removeEventListener('mouseleave', this.registerHandleMouseLeave);
            el.removeEventListener('click', this.registerHandleMouseClick);

            // From the large-up breakpoint we want the menu to show when hovered
            if (this.currentBreakpoint === 'large-up' || this.currentBreakpoint === 'xlarge-up') {
                el.addEventListener('mouseenter', this.registerHandleMouseEnter);
                el.addEventListener('mouseleave', this.registerHandleMouseLeave);
            // On `mobile` breakpoints when want the menu to show on click
            } else {
                el.addEventListener('click', this.registerHandleMouseClick);
            }
        });
    }

    handleMouseEnter(e) {
        var el = e.currentTarget;

        this.showSubNavDelay = setTimeout(() => {
            this.showSubNav(el, e);
        }, this.subNavDelayValueInMiliseconds);
    }

    handleMouseLeave(e) {
        clearTimeout(this.showSubNavDelay);
        this.hideSubNav(e.currentTarget);
    }

    handleMouseClick(e) {
        if (e.currentTarget.hasAttribute(this.subMenuActiveAttribute)) {
            // Hide the subnav when clicking on an active menu item
            this.hideSubNav(e.currentTarget, e);
        } else {
            // It's possible that other menu items are active so hide them first
            this.hideAllSubNavs();
            this.showSubNav(e.currentTarget, e);
        }
    }

    showSubNav(el, e) {
        const subnav = el.querySelector(this.s.subNav);

        if (subnav) {
            el.setAttribute(this.subMenuActiveAttribute, true);
            subnav.classList.remove(this.subMenuHiddenClass);
            // Show the body overlay
            document.body.classList.add(this.bodyOverlayClass);

            e.preventDefault();
        }

        e.stopPropagation();
    }

    hideSubNav(el, e) {
        const subnav = el.querySelector(this.s.subNav);
        if (subnav) {
            el.removeAttribute(this.subMenuActiveAttribute, true);
            subnav.classList.add(this.subMenuHiddenClass);
            // Hide the body overlay
            document.body.classList.remove(this.bodyOverlayClass);

            if (e) {
                e.preventDefault();
            }
        }

        if (e) {
            e.stopPropagation();
        }
    }

    hideAllSubNavs() {
        this.el.querySelectorAll(this.s.menuItem).forEach(el => {
            this.hideSubNav(el);
        });
    }
}

export { Navigation as Navigation };
